module.exports = __webpack_public_path__ + "img/bg-sect-5.a2af0dab.png";